import React, { useState } from "react";
import { Box, Typography, Button } from "@mui/material";

const ctaPairs = [
  { heading: "Have Questions?", subtext: "We are here to help you." },
  {
    heading: "Experience the difference of a disciplined DAM Practice.",
    subtext: "Reach out to our Consultant.",
  },
  {
    heading: "Ready to elevate your assets?",
    subtext: "Partner with our Practice.",
  },
  {
    heading:
      "Explore how our practice-based model can transform your DAM strategy.",
    subtext: "Connect with our Expert.",
  },
  {
    heading: "Explore how our discovery model can transform your DAM strategy.",
    subtext: "Connect with our Expert.",
  },
  {
    heading: "Explore how our discovery model transforms your DAM strategy.",
    subtext: "Connect with our Expert.",
  },
];

const HaveQuestions = () => {
  const [{ heading, subtext }] = useState(
    () => ctaPairs[Math.floor(Math.random() * ctaPairs.length)]
  );

  return (
    <Box
      sx={{
        width: "100%",
        background: "linear-gradient(180deg, #D9EFFF 0%, #FFFFFF 100%)",
        borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
        py: "60px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        px: { xs: 3, sm: 4 },
      }}
    >
      <Typography
        sx={{
          fontSize: "48px",
          fontWeight: 700,
          color: "#2A2177",
          textAlign: "center",
          "@media (max-width: 1200px)": {
            fontSize: "36px",
          },
          "@media (max-width: 780px)": {
            fontSize: "2rem",
          },
        }}
      >
        {heading}
      </Typography>
      <Typography
        sx={{
          fontSize: "24px",
          fontWeight: 400,
          color: "#000000DE",
          textAlign: "center",
          "@media (max-width: 1200px)": {
            fontSize: "20px",
          },
          "@media (max-width: 780px)": {
            fontSize: "18px",
          },
        }}
      >
        {subtext}
      </Typography>
      <Box
        sx={{
          display: "flex",
          gap: 2,
          pt: 4,
          flexWrap: "wrap",
          justifyContent: "center",
        }}
      >
        <Button
          variant="contained"
          href="/contact"
          sx={{
            textTransform: "none",
            fontSize: "14px",
            fontWeight: 600,
            height: "42px",
            width: "142px",
            color: "#ffffff",
            backgroundColor: "#C22A43",
            borderRadius: "20px",
            px: 3,
            py: 1,
            "&:hover": {
              backgroundColor: "#B71C1C",
            },
          }}
        >
          Contact Us
        </Button>
        <Button
          variant="outlined"
          href="https://calendly.com/dam-journey-llc"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            textTransform: "none",
            fontSize: "14px",
            fontWeight: 600,
            height: "42px",
            color: "#C22A43",
            borderColor: "#C22A43",
            borderRadius: "20px",
            px: 3,
            py: 1,
            "&:hover": {
              borderColor: "#B71C1C",
              backgroundColor: "rgba(198, 40, 40, 0.04)",
            },
          }}
        >
          Book Consultation
        </Button>
      </Box>
    </Box>
  );
};

export default HaveQuestions;
